import React, { useEffect, useState } from "react";
import { API_URL } from "../../../config";

const EditCapnoGoDevice = ({
  deviceid,
  editdeviceToggleModal,
  successeditdeviceToggleModal,
  godevicelist,
}) => {
  const [editdata, setEditdata] = useState({});
  const [devicetype, setDevicetype] = useState("");
  const [modules, setModules] = useState([]);
  const [selectedModules, setSelectedModules] = useState([]);
  const [selectedModuleDetails, setSelectedModuleDetails] = useState([]);
  const [errorMessege, setErrorMessege] = useState(false);

  const planModulesMap = {
    BASIC: [],
    ADVANCED: [
      "ADVANCED_FEATURES_MODULE",
      "MULTI_USER_MODULE",
      "PRACTICUMS_MODULE",
      "HRV_MODULE",
    ],
    PROFESSIONAL: [
      "ADVANCED_FEATURES_MODULE",
      "MULTI_USER_MODULE",
      "PRACTICUMS_MODULE",
      "HRV_MODULE",
      "CELL_PHONE_MODULE",
      "CLOUD_DATABASE_MODULE",
      "MANAGEMENT_MODULE",
      "EMG_MUSCLE_FEEDBACK_MODULE",
    ],
  };

  useEffect(() => {
    fetchModules();
    getgodevicebyid();
  }, []);


  const fetchModules = async () => {
    const res = await fetch(API_URL + "/get/all/modules");
    const data = await res.json();
    setModules(data.modules || []);
  };


  const getgodevicebyid = () => {
    fetch(API_URL + "/get/capno-go/device/by/" + deviceid)
      .then((res) => res.json())
      .then((resp) => {
        const data = resp.data[0];
        setEditdata(data);
        setDevicetype(data.device_type);

        if (data.module_ids) {
          const parsed =
            typeof data.module_ids === "string"
              ? JSON.parse(data.module_ids)
              : data.module_ids;

          setSelectedModules(parsed);
        }
      });
  };


  const handleDeviceTypeChange = (e) => {
    const val = e.target.value;
    setDevicetype(val);

    if (val === "null") {
      setErrorMessege(true);
      return;
    }

    setErrorMessege(false);

    const plan =
      val === "11"
        ? "BASIC"
        : val === "12"
        ? "ADVANCED"
        : val === "13"
        ? "PROFESSIONAL"
        : null;

    const selectedEnums = planModulesMap[plan] || [];

    const filteredModules = modules.filter((m) =>
      selectedEnums.includes(m.module_enum)
    );

    const ids = filteredModules.map((m) => m.id);

    setSelectedModules(ids);
    setSelectedModuleDetails(filteredModules);
  };

  // 🔹 Update API
  const editDevice = () => {
    if (!devicetype || devicetype === "null") {
      setErrorMessege(true);
      return;
    }

    const data = {
      device_type: Number(devicetype),
      module_ids: selectedModules,
    };

    fetch(API_URL + "/update/capno-go/device/" + deviceid, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then((response) => {
      if (response.status === 200) {
        editdeviceToggleModal();
        successeditdeviceToggleModal();
        godevicelist();
      } else {
        alert("Update failed");
      }
    });
  };
useEffect(() => {
  if (!modules.length || !selectedModules.length) return;

  const filtered = modules.filter((m) =>
    selectedModules.includes(m.id)
  );

  setSelectedModuleDetails(filtered);
}, [modules, selectedModules]);
  return (
    <div>
      <ul className="deviceformlist">
        <li>
          <div className="select-device-type">
            <select value={devicetype} onChange={handleDeviceTypeChange}>
              <option value="null">Select device type</option>
              <option value="11">GO Basic</option>
              <option value="12">GO Advanced</option>
              <option value="13">GO Professional</option>
            </select>
          </div>

          {errorMessege && (
            <p className="error-message">Field required</p>
          )}
        </li>

     
        {selectedModuleDetails.length > 0 && (
          <li>
            <div
              style={{
                marginTop: "10px",
                padding: "10px",
                border: "1px solid #eee",
                borderRadius: "6px",
                background: "#fafafa",
              }}
            >
              <strong>Modules:</strong>

              <ul style={{ marginTop: "8px", paddingLeft: "18px" }}>
                {selectedModuleDetails.map((m) => (
                  <li key={m.id}>{m.name}</li>
                ))}
              </ul>
            </div>
          </li>
        )}

        <li>
          <div className="addBtn">
            <button onClick={editDevice}>Update</button>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default EditCapnoGoDevice;